module.exports = __webpack_public_path__ + "static/radek-051bb791c55f20c218e123c59813321e.png";